import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Button } from '@edusense/shared-ui-kit';
// --- Styled Components ---
const FormContainer = styled.form`
  background-color: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 600px; // 폼 최대 너비 설정
  margin: 20px auto; // 페이지 내 가운데 정렬 (예시)
`;
const FormGroup = styled.div`
  margin-bottom: 20px;
`;
const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 0.9rem;
`;
const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  box-sizing: border-box; // 패딩 포함 너비 계산
`;
const CourseCreateForm = ({ onSubmit, isLoading })=>{
    const [title, setTitle] = useState('');
    const handleChange = (e)=>{
        setTitle(e.target.value);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!title.trim()) {
            alert('강의 제목을 입력해주세요.');
            return;
        }
        onSubmit({
            title
        });
    };
    return /*#__PURE__*/ _jsxs(FormContainer, {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ _jsx("h2", {
                children: "새 강의 시작하기"
            }),
            /*#__PURE__*/ _jsxs(FormGroup, {
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        htmlFor: "title",
                        children: "강의 제목"
                    }),
                    /*#__PURE__*/ _jsx(Input, {
                        type: "text",
                        id: "title",
                        name: "title",
                        value: title,
                        onChange: handleChange,
                        placeholder: "예: 파이썬 웹 개발 기초",
                        required: true
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Button, {
                type: "submit",
                variant: "primary",
                isLoading: isLoading,
                disabled: isLoading,
                children: [
                    isLoading ? '생성 중...' : '강의 초안 생성',
                    " "
                ]
            })
        ]
    });
};
export default CourseCreateForm;
